import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-unauthorized-page',
    imports: [],
    templateUrl: './unauthorized-page.component.html',
    styleUrl: './unauthorized-page.component.scss'
})
export class UnauthorizedPageComponent {
    private readonly route: ActivatedRoute;

    protected readonly statusCode: number;
    protected readonly heading: string;
    protected readonly message: string;

    constructor(route: ActivatedRoute) {
        this.route = route;
        const authenticationRequired = this.route.snapshot.routeConfig?.path === '401';

        this.statusCode = authenticationRequired ? 401 : 403;
        this.heading = authenticationRequired ? 'Sign in required' : 'You are not authorized';
        this.message = authenticationRequired
            ? 'You must sign in before accessing this application.'
            : 'Your account does not have access to this application.';
    }
}
